import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

import { SalesState } from "../../models";
import {
    getSettingType,
    getTotalCount,
    getTotalCountForType,
    MusicIdProps,
} from "../../selectors";
import { messages } from "../../messages";
import { HeadlineStat } from "../HeadlineStat";

// The presenter
interface Props extends MusicIdProps {
    count: number;
    totalCount: number;
    type: "stream" | "download";
}

const TotalCount = ({ count, totalCount, type }: Props) => {
    const { formatMessage, formatNumber } = useIntl();
    let message = messages.totalStreamsNoValue;
    let title = messages.numberStreams;
    const values: {[key: string]: any} = {
        number: "x",
        total: count,
    };
    if (type === "download") {
        message = messages.totalDownloadsNoValue;
        title = messages.numberDownloads;
    }
    if (count != null) {
        values.number = formatNumber(count);
    }

    return (
        <div className="total-count">
            <HeadlineStat
                value={count}
                totalCount={totalCount}
                label={<FormattedMessage {...message} />}
                title={formatMessage(title, values)}
            />
        </div>
    );
};

// Connect to redux
const mapStateToProps = (state: SalesState, props: MusicIdProps) => {
    return {
        count: getTotalCountForType(state, props),
        totalCount: getTotalCount(state, props),
        type: getSettingType(state),
    };
};

const ConnectedTotalCount = compose<Props, MusicIdProps>(
    connect(mapStateToProps, null),
)(TotalCount);

export {
    TotalCount as TotalCountPresenter,
    ConnectedTotalCount as TotalCount,
};
